import { render, staticRenderFns } from "./SociosListaItem.vue?vue&type=template&id=4f2385cf&"
import script from "./SociosListaItem.vue?vue&type=script&lang=js&"
export * from "./SociosListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports